export default {"src":"/_next/static/media/csv.b12bea0c.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};